import React, { useState, useEffect } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import toast from "react-hot-toast";
import "./login.css";

export default function Login() {
  const { login, loading } = useAuth();
  const history = useHistory();
  const location = useLocation();

  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPwd, setShowPwd] = useState(false);

  const from = (location.state && location.state.from) || { pathname: "/perfil" };

  useEffect(() => {
    if (location.state?.registroExitoso) {
      toast.success(
        location.state?.mensaje || "Cuenta creada correctamente. Ahora inicia sesión."
      );

      history.replace(location.pathname, {
        ...location.state,
        registroExitoso: false,
        mensaje: ""
      });
    }
  }, [location, history]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    try {
      await login({ correo, password });
      history.replace(from);
    } catch (err) {
      setError(err.message || "No se pudo iniciar sesión");
    }
  }

  return (
    <div className="auth container">
      <div className="auth-card">
        <h1 className="auth-title">Iniciar sesión</h1>

        {error && (
          <div className="auth-error">
            {error === "Request failed with status code 401"
              ? "El correo o la contraseña no son correctos."
              : "Ocurrió un problema al iniciar sesión. Intenta nuevamente."}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <label>
            Correo
            <input
              type="email"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              required
              placeholder="tucorreo@dominio.com"
            />
          </label>

          <label className="auth-label">
            Contraseña

            <div className="pwd-row">
              <input
                className="auth-input"
                type={showPwd ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="********"
              />

              <button
                type="button"
                className="pwd-toggle"
                onClick={() => setShowPwd((s) => !s)}
                aria-label={showPwd ? "Ocultar" : "Mostrar"}
              >
                {showPwd ? "Ocultar" : "Mostrar"}
              </button>
            </div>
          </label>

          <div className="auth-forgot">
            <Link to="/forgotPass">¿Olvidaste la contraseña?</Link>
          </div>

          <button className="btn-primary" type="submit" disabled={loading}>
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>

        <p className="auth-alt">
          ¿No tienes cuenta? <Link to="/registro">Crear cuenta</Link>
        </p>
      </div>
    </div>
  );
}